import React from 'react'
import CurrentOpening from '../Home/CurrentOpening'

const CareerPage = () => {
  return (
    <>
       <CurrentOpening/> 
    </>
  )
}

export default CareerPage